// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___1BOm4","open":"open___1lGLn","fromNow":"fromNow___1bmeO","fullDate":"fullDate___22ZTp"};